// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiEye } from "@mdi/js";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import { selectShowAllTops } from "../../context/xdaSettingsSelectors";

function XdaTopsToggle() {
  const showAllTops = useXdaSettingsStore(selectShowAllTops);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleToggle = (active: boolean) => {
    updateXdaSettings({ showAllTops: active });
  };

  return (
    <ToolbarButton
      icon={<Icon path={mdiEye} size={1.5} />}
      active={showAllTops}
      tooltipText={"Show All Tops"}
      overflowLabel={"Show All Tops"}
      onToggle={handleToggle}
      styleKey="xdaToolbar"
    />
  );
}

export default XdaTopsToggle;
